import { render, staticRenderFns } from "./StockLocIngredientCombo.vue?vue&type=template&id=fc4e9546&scoped=true"
import script from "./StockLocIngredientCombo.vue?vue&type=script&lang=js"
export * from "./StockLocIngredientCombo.vue?vue&type=script&lang=js"
import style0 from "./StockLocIngredientCombo.vue?vue&type=style&index=0&id=fc4e9546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4e9546",
  null
  
)

export default component.exports